export default __webpack_public_path__ + "static/media/produtividade.6793d5c7.svg";